import { AxiosResponse } from "axios";
import { EnumPessoaTipo, TypeMateriaisServicos, TypePessoa, TypeSegmentoAtuacao } from "../../Models/Pessoa/Pessoa";
import { Axios } from "../Axios";
import { useQuery } from "@tanstack/react-query";
import RequestUtilitario, { BasicQueryType } from "../../Utils/RequisicaoUtilitario";
import { EnumEnderecoTipo } from "../../Models/Pessoa/Endereco";
import { EnumEmailTipo } from "../../Models/Pessoa/Contato/Email";

export class PessoaService {
    public listarSegmentosDeAtuacao(codigoDoTipoDaPessoa: number){
        return Axios.get<TypeSegmentoAtuacao[]>(`SegmentoAtuacao/listar/${codigoDoTipoDaPessoa}`);
    }

    public listarMateriaisServicos(): Promise<AxiosResponse<TypeMateriaisServicos[]>>{
        return Axios.get<TypeMateriaisServicos[]>(`MaterialServico/listarMateriaisServicos`);
    }
}

export function useListar({
    pessoa,
    ativo,
    tiposPessoaValidos,
    tiposPessoaInValidos,
    comIncludes,
    onSuccess,
    ...rest
}:BasicQueryType<AxiosResponse<TypePessoa[]>, {
    pessoa?:TypePessoa,
    ativo?:boolean,
    tiposPessoaValidos?:number[]|EnumPessoaTipo[],
    tiposPessoaInValidos?:number[]|EnumPessoaTipo[],
    comIncludes?:boolean,
    onSuccess?:((response:AxiosResponse<TypePessoa[]>) => void)
}>) {
    const queryString = RequestUtilitario.objectToQueryString({
        ...(pessoa ?? {}),
        ativo,
        tiposPessoaValidos,
        tiposPessoaInValidos,
        comIncludes : (comIncludes ?? false)
    });

    return useQuery({
        ...rest,
        queryKey : [ "Pessoa.Pessoa.Listar", `Pessoa.Pessoa.Listar?${queryString}` ],
        queryFn : () => Axios.get<TypePessoa[]>(`pessoa/pessoa?${queryString}`).then(resp => {
            onSuccess?.(resp);
            return resp;
        }),
        staleTime : 1000 * 60 * 1,
        select : ({ data }) => data
    });
}

export function useListarContatos({
    codPessoa,
    tipoEndereco,
    tipoEmail,
    tipoTelefone,
    ...rest
}:BasicQueryType<AxiosResponse<TypePessoa|null>, {
    codPessoa:number,
    tipoEndereco:EnumEnderecoTipo,
    tipoEmail:EnumEmailTipo,
    tipoTelefone:EnumEnderecoTipo
}>) {
    const queryString = RequestUtilitario.objectToQueryString({
        tipoEndereco,
        tipoEmail,
        tipoTelefone
    });

    return useQuery({
        ...rest,
        queryKey : [ "Pessoa.Pessoa.BuscarDadosContatos", `Pessoa.Pessoa.BuscarDadosContatos.${codPessoa}?${queryString}` ],
        queryFn : () => Axios.get<TypePessoa|null>(`pessoa/pessoa/contatos/${codPessoa}?${queryString}`),
        staleTime : 1000 * 60 * 1, // 1 minuto
        select : ({ data }) => data
    });
}
export default {
    useListar,
    useListarContatos
}